<template>
  <van-tabbar
    v-model="activeName"
    :border="footerBorder"
    :z-index="zIndex"
    inactive-color="#b6b6b6"
  >
    <van-tabbar-item replace name="home" to="/partner_index">
      <span class="footer-text">首页</span>
      <template #icon="{active}">
        <img :src="active ? home.active : home.normal" class="footer-img" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace name="salary" to="/partner_income_index">
      <span class="footer-text">我的佣金</span>
      <template #icon="{active}">
        <img :src="active ? salary.active : salary.normal" class="footer-img" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace name="user" to="/partner_user_index">
      <span class="footer-text">个人中心</span>
      <template #icon="{active}">
        <img :src="active ? user.active : user.normal" class="footer-img" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  name: "partner-footer",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  watch: {
    $route: function (to, from) {
      this.activeName = to.meta.showFooter;
    },
  },
  data() {
    return {
      footerBorder: false,
      zIndex: 99,
      activeName: this.$route.meta.showFooter,
      home: {
        normal: require("./assets/icon_home.png"),
        active: require("./assets/icon_home_active.png"),
      },
      salary: {
        normal: require("./assets/icon_salary.png"),
        active: require("./assets/icon_salary_active.png"),
      },
      user: {
        normal: require("./assets/icon_user.png"),
        active: require("./assets/icon_user_active.png"),
      },
    };
  },
};
</script>